import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {TenantService} from './tenant.service';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';


@Injectable()
export class CouponsService {
  private http = inject(HttpClient);
  private tenant = inject(TenantService);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);



  constructor() {

  }

  fulfillFreeCourseCoupon(courseId:string, couponCode:string): Observable<any> {
    return this.http.post<any>(
      environment.api.fulfillFreeCouponUrl,
      {
        courseId,
        tenantId: this.tenant.id,
        couponCode
      });


  }

}
